module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#facebook",
      toString: function () {
        return this.url;
      }
    }